export default __webpack_public_path__ + "static/media/BESTAW.670a3d5a.webp";